import { AFFORDABILITY_LABELS, COVERAGE_GOOD_PERCENT, formatCents, type ProjectAssessment } from '@kontor/shared';
import './financing.css';

const percent = (n: number | null) => (n === null ? '–' : `${n.toLocaleString('de-DE')} %`);

/**
 * Tragfähigkeit einer geplanten Rate (KON-256): Überschuss pro Monat vor und nach den Raten, Kapitaldienstdeckung und eine Bewertung mit einem begründenden Satz. Die Bewertung steht
 * als Text und Farbe, damit sie auch ohne Farbsehen lesbar ist.
 */
export function AffordabilityCard({ assessment, title = 'Tragfähigkeit' }: { assessment: Pick<ProjectAssessment, 'affordability' | 'planError'>; title?: string }) {
  const a = assessment.affordability;
  return (
    <section className="card fin-afford" aria-label={title}>
      <h2>{title}</h2>
      {assessment.planError ? (
        <div className="alert alert--error" role="alert">{assessment.planError}</div>
      ) : (
        <>
          <p className={`fin-rating fin-rating--${a.rating}`} role="status"><strong>{AFFORDABILITY_LABELS[a.rating]}.</strong> {a.summary}</p>
          <dl className="fin-afford__grid">
            <div><dt>Überschuss vor Raten</dt><dd>{formatCents(a.surplusBeforeDebtCents)}<small> / Monat</small></dd></div>
            <div><dt>Bestehende Raten</dt><dd>{formatCents(a.existingDebtServiceMonthlyCents)}<small> / Monat</small></dd></div>
            <div><dt>Neue Rate</dt><dd>{formatCents(a.newMonthlyCents)}<small> / Monat</small></dd></div>
            <div><dt>Bleibt übrig</dt><dd className={a.surplusAfterCents < 0 ? 'fin-neg' : ''}>{formatCents(a.surplusAfterCents)}<small> / Monat</small></dd></div>
            <div><dt>Kapitaldienstdeckung heute</dt><dd>{percent(a.coverageBeforePercent)}</dd></div>
            <div><dt>Mit der neuen Rate</dt><dd>{percent(a.coverageAfterPercent)}</dd></div>
          </dl>
          <p className="muted small">Die Kapitaldienstdeckung ist der Überschuss geteilt durch alle Raten. Ab {COVERAGE_GOOD_PERCENT} % gilt die Belastung bei Wirkia als tragfähig, Banken erwarten je nach Branche etwa 120 bis 150 %.{a.burdenAfterPercent !== null ? ` Alle Raten zusammen entsprechen ${percent(a.burdenAfterPercent)} der Einnahmen.` : ''}</p>
        </>
      )}
    </section>
  );
}
